import { Gray_Light_700 } from '@croquiscom/zds';
import { cx } from '@emotion/css';
import styled from '@emotion/styled';

import { TextAlign, Typography } from '@common/styles';

import { Drawer, DrawerProps } from '../Drawer';

export interface HelpDrawerProps extends DrawerProps {
  title: string;
  title_align?: TextAlign;
}

export const HelpDrawer: React.FC<React.PropsWithChildren<HelpDrawerProps>> = ({ title, title_align, children, ...otherProps }) => {
  return (
    <Drawer height='auto' {...otherProps}>
      <Container>
        <Title className={Typography.HEAD_20_BOLD} $align={title_align}>
          {title}
        </Title>
        <Content className={cx('drawer_content', Typography.BODY_14_REGULAR)}>{children}</Content>
      </Container>
    </Drawer>
  );
};

const Container = styled.div`
  padding: 40px 16px 40px;
  letter-spacing: normal;
`;
const Title = styled.h3<{ $align?: TextAlign }>`
  ${({ $align }) => $align && `text-align: ${$align};`}
`;

const Content = styled.div`
  line-height: 16px;
  color: ${Gray_Light_700};

  > p {
    margin: 0 0 24px;

    &:last-of-type {
      margin: 0;
    }

    > span {
      display: block;
      margin: 0 0 8px;
    }
  }

  & ul {
    list-style: disc;
    padding-left: 16px;
  }
`;
